import { BrandfolderHexColors } from '@brandfolder/react';
import { Trans } from '@lingui/macro';
import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

const WhiteButton = styled(Link)`
  background-color: transparent;
  border: 1px solid ${BrandfolderHexColors.White};
  border-radius: 4px;
  color: ${BrandfolderHexColors.White};
  line-height: 20px;
  padding: 15px;
  text-transform: capitalize;
  width: max-content;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-color: ${BrandfolderHexColors.White};
    color: ${BrandfolderHexColors.White};
  }
  &:active {
    background-color: rgba(255, 255, 255, 0.2);
  }
  &:disabled {
    border-color: rgba(255, 255, 255, 0.5);
    color: rgba(255, 255, 255, 0.5);
  }
`;

interface SecondaryWhiteButtonProps {
  buttonText: string;
  linkTo: string;
}

export const SecondaryWhiteButton: FunctionComponent<SecondaryWhiteButtonProps> =
  ({ buttonText, linkTo }) => (
    <WhiteButton to={linkTo}>
      <Trans>{buttonText}</Trans>
    </WhiteButton>
  );
